export default "/images/vendor/flag-icon-css/flags/1x1/at.svg?d7b3791eb6679e92a2bd4447053ebc93";